const { countryCodeEnum } = require('@/constants/country')
const { BankInfoDetail } = require('@/constants/bankInfoDetail')
const { PROMOTION_TYPE } = require('@/constants/promotion')

module.exports = {
  info: {
    url: 'www.vtmarkets.com',
    urlCn: 'www.vtmarketsglobal.com',
    urlTw: 'www.vtmarketsglobal.com/hk',
    urlIran: 'www.global-vtrader.com',
    urlIraq: 'www.vglobaltrader.com',
    urlIT: 'www.vtmarketsit.com',
    map: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14973.672139712427!2d57.4952389!3d-20.2414905!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x217c5b485e823a99%3A0x664d7713ca9d6a73!2sThe%20Catalyst!5e0!3m2!1sen!2ssg!4v1699326487978!5m2!1sen!2ssg',
    mapIran:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.1570730181543!2d-61.2254683241286!3d13.152490387179643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c4751501a16f1a7%3A0x852ca13a834a3fd9!2sFirst%20St%20Vincent%20Bank!5e0!3m2!1sen!2smy!4v1709709585149!5m2!1sen!2smy',
    address: `<span>Level 2, Suite 201, The Catalyst, 40 Silicon Avenue</span><br>
          <span>Ebène</span><br>
          <span>Republic of Mauritius</span>`,
    addressIran: `<span>Euro House, Richmond Hill Road Kingstown VC0100,</span><br>
      <span>St. Vincent and the Grenadines</span>
    `,
    email: 'info@vtmarkets.com',
    name: 'VT Markets Limited',
    nameIran: 'VT Markets LLC',
    depositEmail: 'info@vtmarkets.com',
    withdrawalEmail: 'info@vtmarkets.com',
  },
  withdrawSetup: { checkMethodMinAmount: true, cancelWithdraw: true },
  openLiveAccount: {
    choosePlatform: [
      {
        value: 'mt5',
        label: 'common.choosePlatform.mt5',
      },
      {
        value: 'mt4',
        label: 'common.choosePlatform.mt4',
      },
    ],
    chooseLiveType: [
      {
        img: require('@/assets/images/openAccount/standardStp.png'),
        value: 'standardSTP',
      },
      {
        img: require('@/assets/images/openAccount/standardStpSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/standardStpIslamic.png'),
        value: 'swapFreeStandardSTP',
      },
      // standardSTP, !(MENA & EMEA)
      {
        img: require('@/assets/images/openAccount/vipStp.png'),
        value: '9',
      },
      // swapFreeStandardSTP, !(MENA & EMEA)
      {
        img: require('@/assets/images/openAccount/vipStpSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/vipStpIslamic.png'),
        value: 'swapFreeVipStp',
      },
      {
        img: require('@/assets/images/openAccount/rawEcn.png'),
        value: 'rawECN',
      },
      {
        img: require('@/assets/images/openAccount/rawEcnSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/rawEcnIslamic.png'),
        value: 'swapFreeRawECN',
      },
      {
        img: require('@/assets/images/openAccount/centStp.png'),
        value: 'STANDARD_STP_CENT',
        excludeCountry: {},
        hiddenState: true,
      },
      {
        img: require('@/assets/images/openAccount/centStpSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/centStpIslamic.png'),
        value: 'ISLAMIC_STP_CENT',
        excludeCountry: {},
        hiddenState: true,
      },
      // STANDARD_STP_CENT, !(MENA & EMEA)
      {
        img: require('@/assets/images/openAccount/centVip.png'),
        value: 'vipStpCent',
        excludeCountry: {},
        // hiddenState: true,
      },
      // ISLAMIC_STP_CENT, !(MENA & EMEA)
      {
        img: require('@/assets/images/openAccount/centVipSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/vipCentIslamic.png'),
        value: 'swapFreeVipStpCent',
        excludeCountry: {},
        hiddenState: true,
      },
      {
        img: require('@/assets/images/openAccount/centEcn.png'),
        value: 'RAW_ECN_CENT',
        excludeCountry: {},
        hiddenState: true,
      },
      {
        img: require('@/assets/images/openAccount/centEcnSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/centEcnIslamic.png'),
        value: 'ISLAMIC_ECN_CENT',
        excludeCountry: {},
        hiddenState: true,
      },
      {
        img: require('@/assets/images/openAccount/pamm.png'),
        value: 'PAMM',
      },
    ],
    chooseRegisterType: [
      {
        img: require('@/assets/images/openAccount/standardStp.png'),
        value: 'standardSTP',
      },
      {
        img: require('@/assets/images/openAccount/standardStpSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/standardStpIslamic.png'),
        value: 'swapFreeStandardSTP',
      },
      // standardSTP, !(MENA & EMEA)
      {
        img: require('@/assets/images/openAccount/vipStp.png'),
        value: '9',
      },
      // swapFreeStandardSTP, !(MENA & EMEA)
      {
        img: require('@/assets/images/openAccount/vipStpSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/vipStpIslamic.png'),
        value: 'swapFreeVipStp',
      },
      {
        img: require('@/assets/images/openAccount/rawEcn.png'),
        value: 'rawECN',
      },
      {
        img: require('@/assets/images/openAccount/rawEcnSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/rawEcnIslamic.png'),
        value: 'swapFreeRawECN',
      },
      {
        img: require('@/assets/images/openAccount/centStp.png'),
        value: 'STANDARD_STP_CENT',
        excludeCountry: {},
        hiddenState: true,
      },
      {
        img: require('@/assets/images/openAccount/centStpSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/centStpIslamic.png'),
        value: 'ISLAMIC_STP_CENT',
        excludeCountry: {},
        hiddenState: true,
      },
      // STANDARD_STP_CENT, !(MENA & EMEA)
      {
        img: require('@/assets/images/openAccount/centVip.png'),
        value: 'vipStpCent',
        excludeCountry: {},
        hiddenState: true,
      },
      // ISLAMIC_STP_CENT, !(MENA & EMEA)
      {
        img: require('@/assets/images/openAccount/centVipSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/vipCentIslamic.png'),
        value: 'swapFreeVipStpCent',
        excludeCountry: {},
        hiddenState: true,
      },
      {
        img: require('@/assets/images/openAccount/centEcn.png'),
        value: 'RAW_ECN_CENT',
        excludeCountry: {},
        hiddenState: true,
      },
      {
        img: require('@/assets/images/openAccount/centEcnSwapFree.png'),
        imgIslamic: require('@/assets/images/openAccount/centEcnIslamic.png'),
        value: 'ISLAMIC_ECN_CENT',
        excludeCountry: {},
        hiddenState: true,
      },
    ],
    mt4DemoChooseType: [
      {
        img: require('@/assets/images/openAccount/standardStp.png'),
        value: 'standardSTP',
      },
      {
        img: require('@/assets/images/openAccount/rawEcn.png'),
        value: 'rawECN',
      },
    ],
    mt5DemoChooseType: [
      {
        img: require('@/assets/images/openAccount/standardStp.png'),
        value: 'standardSTP',
      },
      {
        img: require('@/assets/images/openAccount/rawEcn.png'),
        value: 'rawECN',
      },
    ],
    hkdIncludeCountry: [countryCodeEnum.CHINA, countryCodeEnum.HONG_KONG, countryCodeEnum.MACAO],
    uscIncludeCountry: [
      countryCodeEnum.PHILIPPINES,
      countryCodeEnum.THAILAND,
      countryCodeEnum.VIETNAM,
      countryCodeEnum.INDIA,
      countryCodeEnum.BRAZIL,
      countryCodeEnum.MEXICO,
      countryCodeEnum.COLOMBIA,
      countryCodeEnum.ARGENTINA,
      countryCodeEnum.PERU,
      countryCodeEnum.CHILE,
      countryCodeEnum.VENEZUELA,
      countryCodeEnum.ECUADOR,
      countryCodeEnum.BOLIVIA,
      countryCodeEnum.HAITI,
      countryCodeEnum.CUBA,
      countryCodeEnum.DOMINICAN_REPUBLIC,
      countryCodeEnum.HONDURAS,
      countryCodeEnum.PARAGUAY,
      countryCodeEnum.NICARAGUA,
      countryCodeEnum.EL_SALVADOR,
      countryCodeEnum.COSTA_RICA,
      countryCodeEnum.PANAMA,
      countryCodeEnum.URUGUAY,
      countryCodeEnum.JAMAICA,
      countryCodeEnum.TRINIDAD_AND_TOBAGO,
      countryCodeEnum.GUYANA,
      countryCodeEnum.SURINAME,
      countryCodeEnum.BELIZE,
      countryCodeEnum.BAHAMAS,
      countryCodeEnum.BARBADOS,
      countryCodeEnum.SAINT_LUCIA,
      countryCodeEnum.GRENADA,
      countryCodeEnum.SAINT_VINCENT_AND_THE_GRENADINES,
      countryCodeEnum.ANTIGUA_AND_BARBUDA,
      countryCodeEnum.DOMINICA,
      countryCodeEnum.ST_KITTS_NEVIS,
      countryCodeEnum.PUERTO_RICO,
      countryCodeEnum.GUADELOUPE,
      countryCodeEnum.MARTINIQUE,
      countryCodeEnum.FRENCH_GUIANA,
      countryCodeEnum.ARUBA,
      countryCodeEnum.VIRGIN_ISLANDS_US,
      countryCodeEnum.VIRGIN_ISLANDS,
      countryCodeEnum.CAYMAN_ISLANDS,
      countryCodeEnum.SINT_MAARTEN,
      countryCodeEnum.TURKS_AND_CAICOS_ISLANDS,
      countryCodeEnum.ANGUILLA,
      countryCodeEnum.TAIWAN,
      countryCodeEnum.FALKLAND_ISLANDS,
      countryCodeEnum.GUATEMALA,
      countryCodeEnum.LAOS,
      countryCodeEnum.SPAIN,
      countryCodeEnum.PORTUGAL,
      countryCodeEnum.MALAYSIA,
      countryCodeEnum.HONG_KONG,
      countryCodeEnum.MACAO,
    ],
    uscOnly: [
      {
        img: require('@/assets/images/openAccount/USD.png'),
        value: '￠ USC',
        currency: 'USC',
        symbolLabel: 'currency.usc.symbolLabel',
        excludeCountry: {},
        monetaryPolicy: {
          standardSTP: true,
          9: true, // standardSTP, !(MENA & EMEA)
          rawECN: true,
          swapFreeStandardSTP: true,
          swapFreeRawECN: true,
          PAMM: true,
          swapFreeVipStp: true, // swapFreeStandardSTP, !(MENA & EMEA)
          mt5: true,
          mt4: true,
        },
        hiddenState: true,
      },
    ],
    chooseCurrency: [
      {
        img: require('@/assets/images/openAccount/USD.png'),
        value: '$ USD',
        currency: 'USD',
        symbolLabel: 'currency.usd.symbolLabel',
        excludeCountry: {},
        monetaryPolicy: {
          STANDARD_STP_CENT: true,
          vipStpCent: true, // STANDARD_STP_CENT, !(MENA & EMEA)
          RAW_ECN_CENT: true,
          ISLAMIC_STP_CENT: true,
          swapFreeVipStpCent: true, // ISLAMIC_STP_CENT, !(MENA & EMEA)
          ISLAMIC_ECN_CENT: true,
          mt5: true,
          mt4: true,
        },
      },
      {
        img: require('@/assets/images/openAccount/AUD.png'),
        value: '$ AUD',
        currency: 'AUD',
        symbolLabel: 'currency.aud.symbolLabel',
        excludeCountry: {},
        monetaryPolicy: {
          STANDARD_STP_CENT: true,
          vipStpCent: true, // STANDARD_STP_CENT, !(MENA & EMEA)
          RAW_ECN_CENT: true,
          ISLAMIC_STP_CENT: true,
          swapFreeVipStpCent: true, // ISLAMIC_STP_CENT, !(MENA & EMEA)
          ISLAMIC_ECN_CENT: true,
          mt5: true,
          mt4: true,
        },
      },
      {
        img: require('@/assets/images/openAccount/GBP.png'),
        value: '£ GBP',
        currency: 'GBP',
        symbolLabel: 'currency.gbp.symbolLabel',
        excludeCountry: {},
        monetaryPolicy: {
          STANDARD_STP_CENT: true,
          vipStpCent: true, // STANDARD_STP_CENT, !(MENA & EMEA)
          RAW_ECN_CENT: true,
          ISLAMIC_STP_CENT: true,
          swapFreeVipStpCent: true, // ISLAMIC_STP_CENT, !(MENA & EMEA)
          ISLAMIC_ECN_CENT: true,
          mt5: true,
          mt4: true,
        },
      },
      {
        img: require('@/assets/images/openAccount/CAD.png'),
        value: '$ CAD',
        currency: 'CAD',
        symbolLabel: 'currency.cad.symbolLabel',
        excludeCountry: {},
        monetaryPolicy: {
          STANDARD_STP_CENT: true,
          vipStpCent: true, // STANDARD_STP_CENT, !(MENA & EMEA)
          RAW_ECN_CENT: true,
          ISLAMIC_STP_CENT: true,
          swapFreeVipStpCent: true, // ISLAMIC_STP_CENT, !(MENA & EMEA)
          ISLAMIC_ECN_CENT: true,
          mt5: true,
          mt4: true,
        },
      },
      {
        img: require('@/assets/images/openAccount/EUR.png'),
        value: '€ EUR',
        currency: 'EUR',
        symbolLabel: 'currency.eur.symbolLabel',
        excludeCountry: {},
        monetaryPolicy: {
          STANDARD_STP_CENT: true,
          vipStpCent: true, // STANDARD_STP_CENT, !(MENA & EMEA)
          RAW_ECN_CENT: true,
          ISLAMIC_STP_CENT: true,
          swapFreeVipStpCent: true, // ISLAMIC_STP_CENT, !(MENA & EMEA)
          ISLAMIC_ECN_CENT: true,
          mt5: true,
          mt4: true,
        },
      },
      {
        img: require('@/assets/images/openAccount/HKD.png'),
        value: '$ HKD',
        currency: 'HKD',
        symbolLabel: 'currency.hkd.symbolLabel',
        excludeCountry: {},
        monetaryPolicy: {
          mt5: true,
          mt4: true,
        },
      },
      {
        img: require('@/assets/images/openAccount/JPY.png'),
        value: '￥ JPY',
        currency: 'JPY',
        symbolLabel: 'currency.jpy.symbolLabel',
        excludeCountry: {
          1: true, // China
        },
        monetaryPolicy: {
          STANDARD_STP_CENT: true,
          vipStpCent: true, // STANDARD_STP_CENT, !(MENA & EMEA)
          RAW_ECN_CENT: true,
          ISLAMIC_STP_CENT: true,
          swapFreeVipStpCent: true, // ISLAMIC_STP_CENT, !(MENA & EMEA)
          ISLAMIC_ECN_CENT: true,
          swapFreeRawECN: true,
          swapFreeStandardSTP: true,
          swapFreeVipStp: true, // swapFreeStandardSTP, !(MENA & EMEA)
          PAMM: true,
          mt5: true,
          mt4: true,
        },
      },
      {
        img: require('@/assets/images/openAccount/USD.png'),
        value: '￠ USC',
        currency: 'USC',
        symbolLabel: 'currency.usc.symbolLabel',
        excludeCountry: {},
        monetaryPolicy: {
          standardSTP: true,
          9: true, // standardSTP, !(MENA & EMEA)
          rawECN: true,
          swapFreeStandardSTP: true,
          swapFreeRawECN: true,
          PAMM: false,
          swapFreeVipStp: true, // swapFreeStandardSTP, !(MENA & EMEA)
          mt5: true,
          mt4: true,
        },
        hiddenState: true,
      },
    ],
    chooseLeverage: [100, 200, 300, 400, 500],
    chooseBalance: [
      { value: 1000, name: '$1000' },
      { value: 2500, name: '$2,500' },
      { value: 5000, name: '$5k' },
      { value: 10000, name: '$10k' },
      { value: 25000, name: '$25k' },
      { value: 50000, name: '$50k' },
      { value: 100000, name: '$100k' },
    ],
    chooseAccountType: [
      'STANDARD_STP_CENT',
      'ISLAMIC_STP_CENT',
      'RAW_ECN_CENT',
      'ISLAMIC_ECN_CENT',
      'vipStpCent',
      'swapFreeVipStpCent',
    ],
    getAgreeCondition: 'openAdditAcc.svg.disclaimer',
  },
  getMetaTraderLinks: {
    mt4: {
      Windows: 'https://download.mql5.com/cdn/web/11079/mt4/vtmarkets4setup.exe',
      MacOS: '',
      iPhone:
        'https://download.mql5.com/cdn/mobile/mt4/ios?server=VTMarkets-Demo,VTMarkets-Live,VTMarkets-Live%202,VTMarkets-Live%203,VTMarkets-Live%204,VTMarkets-Live%205,VTMarkets-Live%206,VTMarkets-Live%207,VTMarkets-Live%208,VTMarkets-Live%209',
      Android:
        'https://download.mql5.com/cdn/mobile/mt4/android?server=VTMarkets-Demo,VTMarkets-Live,VTMarkets-Live%202,VTMarkets-Live%203,VTMarkets-Live%204,VTMarkets-Live%205,VTMarkets-Live%206,VTMarkets-Live%207,VTMarkets-Live%208,VTMarkets-Live%209',
      // iPhone:
      //   'https://download.mql5.com/cdn/mobile/mt4/ios?server=VTMarkets-Demo,VTMarkets-Live,VTMarkets-Live%202,VTMarkets-Live%203,VTMarkets-Live%204,VTMarkets-Live%205,VTMarkets-Live%206',
      // Android:
      //   'https://download.mql5.com/cdn/mobile/mt4/android?server=VTMarkets-Demo,VTMarkets-Live,VTMarkets-Live%202,VTMarkets-Live%203,VTMarkets-Live%204,VTMarkets-Live%205,VTMarkets-Live%206',
      WebTrader: 'https://webtrader.vtmarkets.com',
    },
    mt5: {
      Windows: 'https://download.mql5.com/cdn/web/vt.markets.pty/mt5/vtmarkets5setup.exe',
      MacOS: '',
      iPhone: 'https://download.mql5.com/cdn/mobile/mt5/ios?server=VTMarkets-Demo,VTMarkets-Live,VTMarkets-Live%202',
      Android:
        'https://download.mql5.com/cdn/mobile/mt5/android?server=VTMarkets-Demo,VTMarkets-Live,VTMarkets-Live%202',
      WebTrader: 'https://www3.vtmt5web.com',
    },
    app: {
      link: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
    },
  },
  bankInfoDetails: {
    EQUALS: new BankInfoDetail({
      account_name() {
        return 'VT Markets Pty Ltd'
      },
      iban() {
        return 'GB15SPPV23188496501860'
      },
      account_number() {
        return '96501860'
      },
      beneficiary_swift() {
        return 'SPPVGB2L'
      },
      sort() {
        return '23-18-84'
      },
      bank_name() {
        return 'Equals Money UK'
      },
      bank_address() {
        return 'Vintners Place, 68 Upper Thames St, London EC4V 3BJ'
      },
    }),
    NAB: new BankInfoDetail({
      account_name(currency) {
        switch (currency) {
          case 'USD':
          case 'USC':
          case 'EUR':
          case 'GBP':
          case 'CAD':
          case 'JPY':
          case 'AUD':
            return 'VT Markets Pty Ltd'
          default:
            return null
        }
      },
      address(currency) {
        switch (currency) {
          case 'USD':
          case 'USC':
          case 'EUR':
          case 'GBP':
          case 'CAD':
          case 'JPY':
          case 'AUD':
            return 'Level 16, 309 Kent Street, Sydney NSW 2000'
          default:
            return null
        }
      },
      account_number(currency) {
        switch (currency) {
          case 'USD':
          case 'USC':
            return 'VTMAKUSD01'
          case 'EUR':
            return 'VTMAKEUR01'
          case 'GBP':
            return 'VTMAKGBP01'
          case 'CAD':
            return 'VTMAKCAD01'
          case 'JPY':
            return 'VTMAKJPY01'
          case 'AUD':
            return '76-386-7227'
          default:
            return null
        }
      },
      beneficiary_swift(currency) {
        switch (currency) {
          case 'USD':
          case 'USC':
          case 'EUR':
          case 'GBP':
          case 'CAD':
          case 'JPY':
          case 'AUD':
            return 'NATAAU3303M'
          default:
            return null
        }
      },
      bsb_number(currency) {
        switch (currency) {
          case 'USD':
          case 'USC':
          case 'EUR':
          case 'GBP':
          case 'CAD':
          case 'JPY':
          case 'AUD':
            return '082-080'
          default:
            return null
        }
      },
      bank_name(currency) {
        switch (currency) {
          case 'USD':
          case 'USC':
          case 'EUR':
          case 'GBP':
          case 'CAD':
          case 'JPY':
          case 'AUD':
            return 'National Australia Bank'
          default:
            return null
        }
      },
      bank_address(currency) {
        switch (currency) {
          case 'USD':
          case 'USC':
          case 'EUR':
          case 'GBP':
          case 'CAD':
          case 'JPY':
          case 'AUD':
            return '500 Bourke Street, Melbourne Victoria 3000 '
          default:
            return null
        }
      },
    }),
    OPENPAYD: new BankInfoDetail({
      account_name() {
        return 'VT Markets Pty Ltd'
      },
      iban(currency) {
        switch (currency) {
          case 'EUR':
            return 'GB67SEOU00994400195892'
          case 'GBP':
            return 'GB89CLRB04051100260201'
          case 'USD':
          case 'USC':
            return 'GB73CLRB04271458485455'
          default:
            return null
        }
      },
      account_number(currency) {
        switch (currency) {
          case 'EUR':
            return '00195892'
          case 'GBP':
            return '260201'
          case 'USD':
          case 'USC':
            return '58485455'
          default:
            return null
        }
      },
      beneficiary_swift(currency) {
        switch (currency) {
          case 'EUR':
            return 'SEOUGB21'
          case 'GBP':
            return 'CLRBGB22'
          case 'USD':
          case 'USC':
            return 'CLRBGB22'
          default:
            return null
        }
      },
      sort(currency) {
        switch (currency) {
          case 'GBP':
            return '04-05-11'
          default:
            return null
        }
      },
      bank_name(currency) {
        switch (currency) {
          case 'EUR':
            return 'SettleGo Solutions'
          case 'GBP':
          case 'USD':
          case 'USC':
            return 'ClearBank'
          default:
            return null
        }
      },
    }),
    BLACKTHORN: new BankInfoDetail({
      account_name(currency) {
        switch (currency) {
          case 'USD':
          case 'USC':
            return 'VT Global South Africa '
          default:
            return 'VT Markets Pty Ltd'
        }
      },
      iban(currency, countryCode) {
        switch (currency) {
          case 'EUR':
            return countryCode === countryCodeEnum.GUADELOUPE || countryCode === countryCodeEnum.FRENCH_POLYNESIA
              ? 'GB60BLFN04270647056426'
              : 'DE56202208000096503298'
          case 'GBP':
            return 'GB73BLFN04135000019760'
          case 'CAD':
            return 'GB60BLFN04270647056426'
          case 'USD':
          case 'USC':
            return countryCode !== countryCodeEnum.CHINA ? 'GB73CLRB04271458485455' : 'GB60BLFN04270647056426'
          default:
            return null
        }
      },
      address(currency, countryCode) {
        switch (currency) {
          case 'USD':
          case 'USC':
            return countryCode === countryCodeEnum.CHINA
              ? '9 Lilian Avenue, Lilianton Boksburg, Gauteng, South Africa 1459'
              : null
          default:
            return '9 Lilian Avenue, Lilianton Boksburg, Gauteng, South Africa 1459'
        }
      },
      account_number(currency, countryCode) {
        switch (currency) {
          case 'GBP':
            return '00019760'
          case 'USD':
          case 'USC':
            return countryCode !== countryCodeEnum.CHINA ? '58485455' : '26315299631'
          default:
            return null
        }
      },
      intermediary_swift(currency, countryCode) {
        switch (currency) {
          case 'EUR':
            return countryCode === countryCodeEnum.GUADELOUPE || countryCode === countryCodeEnum.FRENCH_POLYNESIA
              ? 'CHASDEFX'
              : null
          case 'CAD':
            return 'CHASGB2L'
          case 'USD':
          case 'USC':
            return countryCode === countryCodeEnum.CHINA ? 'CHASUS33' : null
          default:
            return null
        }
      },
      beneficiary_swift(currency, countryCode) {
        switch (currency) {
          case 'EUR':
            return countryCode === countryCodeEnum.GUADELOUPE || countryCode === countryCodeEnum.FRENCH_POLYNESIA
              ? 'CLRBGB22'
              : 'SXPYDEHHXXX'
          case 'CAD':
            return 'CLRBGB22'
          case 'GBP':
            return 'BLFNGB21'
          case 'USD':
          case 'USC':
            return countryCode !== countryCodeEnum.CHINA ? 'CLRBGB22' : 'BLFNGB21'
          default:
            return null
        }
      },
      sort(currency) {
        switch (currency) {
          case 'GBP':
            return '041350'
          default:
            return null
        }
      },
      bank_name(currency, countryCode) {
        switch (currency) {
          case 'EUR':
            return countryCode === countryCodeEnum.GUADELOUPE || countryCode === countryCodeEnum.FRENCH_POLYNESIA
              ? 'Clear Bank'
              : 'Banking Circle Denmark'
          case 'CAD':
          case 'GBP':
            return 'Blackthorn Finance Ltd'
          case 'USD':
          case 'USC':
            return countryCode !== countryCodeEnum.CHINA ? 'Clearbank' : 'Blackthorn Finance Ltd'
          default:
            return null
        }
      },
      bank_address(currency, countryCode) {
        switch (currency) {
          case 'EUR':
            return countryCode === countryCodeEnum.GUADELOUPE || countryCode === countryCodeEnum.FRENCH_POLYNESIA
              ? 'Bristol, United Kingdom'
              : 'Banking Circle – German Branch 80333 München'
          case 'CAD':
            return 'Borough Yards, 13 Dirty Lane, London SE1 9PA'
          case 'GBP':
            return 'Unit 8, 74 Back Church Lane, London, England, E1 1LX'
          case 'USD':
          case 'USC':
            return countryCode === countryCodeEnum.CHINA ? 'Unit 8, 74 Back Church Lane, London, England, E1 1LX' : null
          default:
            return null
        }
      },
    }),
  },
  banner(url) {
    return [
      {
        centerImg: require('@/assets/images/banner/web-trader.png'),
        title: `POWERFUL.\nDYNAMIC.\n<span class='text-blueG0'>POTENT.</span>`,
        subTitle: `Trading now comes with an <span class="text-blueG0 font-bold underline underline-offset-2 xs:underline-offset-4 md:underline-offset-6">upgrade</span>.`,
        buttonLink: `https://protrader.vtms.live/`,
        buttonText: 'Try TradingView',
        extraClass: ['webtrader-banner'],
        bannerVersion: 'v7',
        excludeCountries: null,
        onlyForCountries: null,
        buttonClass: 'blue_button',
        isHtml: true,
      },
      {
        bannerVersion: 'tradingContest',
        filterEligibleCampaign: PROMOTION_TYPE.TRADING_CONTEST,
      },
      {
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        isTranslation: true,
        title: 'banner.vpsRefund.title',
        subTitle: 'banner.vpsRefund.subTitle',
        buttonLink: `/vpsRefund`,
        buttonText: 'banner.vpsRefund.buttonText',
        extraClass: ['info_left', 'title_single_line', 'vps'],
        bannerVersion: 'v3',
        customBg: 'vps',
        excludeCountries: null,
        onlyForCountries: {
          [countryCodeEnum.ALAND_ISLANDS]: true,
          [countryCodeEnum.ALBANIA]: true,
          [countryCodeEnum.ALGERIA]: true,
          [countryCodeEnum.ANDORRA]: true,
          [countryCodeEnum.ANGOLA]: true,
          [countryCodeEnum.ARGENTINA]: true,
          [countryCodeEnum.ARMENIA]: true,
          [countryCodeEnum.ARUBA]: true,
          [countryCodeEnum.AUSTRIA]: true,
          [countryCodeEnum.AZERBAIJAN]: true,
          [countryCodeEnum.BARBADOS]: true,
          [countryCodeEnum.BELGIUM]: true,
          [countryCodeEnum.BELIZE]: true,
          [countryCodeEnum.BOLIVIA]: true,
          [countryCodeEnum.BRAZIL]: true,
          [countryCodeEnum.BULGARIA]: true,
          [countryCodeEnum.CAYMAN_ISLANDS]: true,
          [countryCodeEnum.CHILE]: true,
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.COLOMBIA]: true,
          [countryCodeEnum.COSTA_RICA]: true,
          [countryCodeEnum.CROATIA]: true,
          [countryCodeEnum.CUBA]: true,
          [countryCodeEnum.CYPRUS]: true,
          [countryCodeEnum.CZECH_REPUBLIC]: true,
          [countryCodeEnum.DENMARK]: true,
          [countryCodeEnum.DOMINICA]: true,
          [countryCodeEnum.DOMINICAN_REPUBLIC]: true,
          [countryCodeEnum.ECUADOR]: true,
          [countryCodeEnum.EL_SALVADOR]: true,
          [countryCodeEnum.ESTONIA]: true,
          [countryCodeEnum.FALKLAND_ISLANDS_MALVINAS]: true,
          [countryCodeEnum.FAROE_ISLAND]: true,
          [countryCodeEnum.FINLAND]: true,
          [countryCodeEnum.FRANCE]: true,
          [countryCodeEnum.FRENCH_GUIANA]: true,
          [countryCodeEnum.GEORGIA]: true,
          [countryCodeEnum.GERMANY]: true,
          [countryCodeEnum.GIBRALTAR]: true,
          [countryCodeEnum.GREECE]: true,
          [countryCodeEnum.GREENLAND]: true,
          [countryCodeEnum.GRENADA]: true,
          [countryCodeEnum.GUADELOUPE]: true,
          [countryCodeEnum.GUATEMALA]: true,
          [countryCodeEnum.GUERNSEY]: true,
          [countryCodeEnum.GUYANA]: true,
          [countryCodeEnum.HAITI]: true,
          [countryCodeEnum.HONDURAS]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.HUNGARY]: true,
          [countryCodeEnum.ICELAND]: true,
          [countryCodeEnum.INDONESIA]: true,
          [countryCodeEnum.IRELAND]: true,
          [countryCodeEnum.ISLE_OF_MAN]: true,
          [countryCodeEnum.ISRAEL]: true,
          [countryCodeEnum.ITALY]: true,
          [countryCodeEnum.JAMAICA]: true,
          [countryCodeEnum.JERSEY]: true,
          [countryCodeEnum.KOSOVO]: true,
          [countryCodeEnum.LATVIA]: true,
          [countryCodeEnum.LIECHTENSTEIN]: true,
          [countryCodeEnum.LITHUANIA]: true,
          [countryCodeEnum.LUXEMBOURG]: true,
          [countryCodeEnum.MACAO]: true,
          [countryCodeEnum.MACEDONIA]: true,
          [countryCodeEnum.MALTA]: true,
          [countryCodeEnum.MARTINIQUE]: true,
          [countryCodeEnum.MEXICO]: true,
          [countryCodeEnum.MOLDOVA]: true,
          [countryCodeEnum.MONACO]: true,
          [countryCodeEnum.MONTSERRAT]: true,
          [countryCodeEnum.MOROCCO]: true,
          [countryCodeEnum.NETHERLANDS]: true,
          [countryCodeEnum.NETHERLANDS_ANTILLES]: true,
          [countryCodeEnum.NICARAGUA]: true,
          [countryCodeEnum.NORWAY]: true,
          [countryCodeEnum.PANAMA]: true,
          [countryCodeEnum.PARAGUAY]: true,
          [countryCodeEnum.PERU]: true,
          [countryCodeEnum.POLAND]: true,
          [countryCodeEnum.PORTUGAL]: true,
          [countryCodeEnum.PUERTO_RICO]: true,
          [countryCodeEnum.ROMANIA]: true,
          [countryCodeEnum.SAINT_BARTHELEMY]: true,
          [countryCodeEnum.ST_HELENA]: true,
          [countryCodeEnum.ST_KITTS_NEVIS]: true,
          [countryCodeEnum.SAINT_LUCIA]: true,
          [countryCodeEnum.SAINT_MARTIN]: true,
          [countryCodeEnum.SAINT_VINCENT_AND_THE_GRENADINES]: true,
          [countryCodeEnum.SAN_MARINO]: true,
          [countryCodeEnum.SERBIA]: true,
          [countryCodeEnum.SINT_MAARTEN]: true,
          [countryCodeEnum.SLOVAKIA]: true,
          [countryCodeEnum.SLOVENIA]: true,
          [countryCodeEnum.SPAIN]: true,
          [countryCodeEnum.SURINAME]: true,
          [countryCodeEnum.SVALBARD_AND_JAN_MAYEN]: true,
          [countryCodeEnum.SWEDEN]: true,
          [countryCodeEnum.SWITZERLAND]: true,
          [countryCodeEnum.TRINIDAD_AND_TOBAGO]: true,
          [countryCodeEnum.TURKS_AND_CAICOS_ISLANDS]: true,
          [countryCodeEnum.UNITED_KINGDOM]: true,
          [countryCodeEnum.URUGUAY]: true,
          [countryCodeEnum.VATICAN_CITY_STATE]: true,
          [countryCodeEnum.VIETNAM]: true,
          [countryCodeEnum.VIRGIN_ISLANDS]: true,
        },
      },
      // {
      //   smallBgImg: require('@/assets/images/banner/eos.png'),
      //   eosBanner: true, //this is special for eosBanner which include isTranslation as true as well.
      //   title: 'banner.eos.title',
      //   subTitle: 'banner.eos.subTitle',
      //   bannerVersion: 'v3',
      //   link: `/clubBleu`,
      //   extraClass: ['info_left', 'title_single_line', 'vps'],
      //   customBg: 'eos',
      // },
      {
        rightSideImg: require('@/assets/images/banner/fgp/human.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        infoLogo: require('@/assets/images/banner/fgp/logo.png'),
        alignedLogo: require('@/assets/images/banner/fgp/logo.png'),
        title: 'banner.fundsGrowthPromotion.title',
        subTitle: 'banner.fundsGrowthPromotion.subTitle',
        isTranslation: true,
        extraClass: ['info_left', 'title_single_line', 'fgp'],
        bannerVersion: 'v3',
        excludeCountries: null,
        onlyForCountries: null,
        filterEligibleCampaign: PROMOTION_TYPE.FUNDS_GROWTH_PROMO_V2,
        customBg: 'fgp',
        rightSideImgClass: 'fgp',
      },
      // {
      //   rightSideImg: require('@/assets/images/banner/ramadhan.png'),
      //   rightSideImgExtraStyle: { top: '-420px' },
      //   smallBgImg: require('@/assets/images/banner/ramadhan@3x.png'),
      //   title: 'The Bonus for Good',
      //   subTitle: 'Register today and get 100% special Ramadan deposit bonus on your first deposit',
      //   buttonLink: `/depositFunds`,
      //   buttonText: 'Deposit now',
      //   buttonDisabled: false,
      //   extraClass: ['info_left', 'ramadhan_banner'],
      //   bannerVersion: 'v5',
      //   excludeCountries: null,
      //   onlyForCountries: {
      //     [countryCodeEnum.MALAYSIA]: true,
      //   },
      // },
      // {
      //   rightSideImg: require('@/assets/images/banner/ramadhan_id.png'),
      //   rightSideImgExtraStyle: { top: '-420px' },
      //   smallBgImg: require('@/assets/images/banner/ramadhan_id@3x.png'),
      //   title: 'Bonus Eksklusif',
      //   subTitle: 'Daftar sekarang dan dapatkan bonus deposit spesial Ramadhan 50% pada deposit pertama Anda',
      //   buttonLink: `/depositFunds`,
      //   buttonText: 'Deposit Sekarang',
      //   buttonDisabled: false,
      //   extraClass: ['info_left', 'ramadhan_banner'],
      //   bannerVersion: 'v5',
      //   excludeCountries: null,
      //   onlyForCountries: {
      //     [countryCodeEnum.INDONESIA]: true,
      //   },
      // },
      {
        rightSideImg: require('@/assets/images/banner/person_10.png'),
        title: 'Official Partner of ',
        subTitle: 'Maserati MSG Racing',
        buttonLink: `https://www.vtmarkets.com/sponsorship/`,
        buttonText: 'Learn more',
        extraClass: ['info_left', 'maserati_banner'],
        bannerVersion: 'v7',
        excludeCountries: null,
        onlyForCountries: null,
        logo: require('@/assets/images/banner/logo.png'),
        bgColor: 'blue_bg',
        buttonClass: 'white_button',
      },
      // {
      //   rightSideImg: require('@/assets/images/banner/maserati.png'),
      //   smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
      //   title: 'banner.maserati.title',
      //   subTitle: 'banner.maserati.subTitle',
      //   isTranslation: true,
      //   buttonLink: null,
      //   languageButtonLink: {
      //     default: `https://www.vtmarkets.com/company/about-us/sponsorships/`,
      //     zh_CN: 'https://www.vtmarketsnet.com/company/about-us/sponsorships/',
      //     zh_TW: 'https://www.vtmarkets.com.tw/about-us/sponsorships/',
      //   },
      //   buttonText: 'banner.maserati.button',
      //   extraClass: ['info_left', 'maserati_banner'],
      //   bannerVersion: 'v3',
      //   excludeCountries: null,
      //   onlyForCountries: null,
      // },
      {
        rightSideImg: require('@/assets/images/banner/person_9.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'banner.affiliateChallengerCup.title',
        subTitle: 'banner.affiliateChallengerCup.subTitle',
        buttonLink: 'https://www.vtaffiliates.com/challenger-cup-2023/',
        buttonText: 'banner.affiliateChallengerCup.buttonText',
        extraClass: 'info_left',
        imgClass: 'img_wrap',
        bannerVersion: 'v6',
        iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        tncLink: 'https://www.vtaffiliates.com/challenger-cup-2023/',
        tncText: 'banner.tncText',
        excludeCountries: {
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.MACAO]: true,
          [countryCodeEnum.VIETNAM]: true,
          [countryCodeEnum.THAILAND]: true,
          [countryCodeEnum.INDONESIA]: true,
          [countryCodeEnum.PAKISTAN]: true,
          [countryCodeEnum.BANGLADESH]: true,
          [countryCodeEnum.MALAYSIA]: true,
          [countryCodeEnum.JAPAN]: true,
          [countryCodeEnum.KOREA]: true,
          [countryCodeEnum.INDIA]: true,
          [countryCodeEnum.PHILIPPINES]: true,
        },
        onlyForCountries: null,
      },
      // {
      //   rightSideImg: require('@/assets/images/banner/person_8.png'),
      //   rightSideImgExtraStyle: { top: '-452px' },
      //   smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
      //   title: 'banner.tradingContest.title',
      //   subTitle: 'banner.tradingContest.subTitle',
      //   buttonLink: `/tradingContest/about`,
      //   buttonText: 'banner.tradingContest.buttonText',
      //   buttonDisabled: true,
      //   extraClass: 'info_left',
      //   bannerVersion: 'v5',
      //   iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
      //   andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
      //   excludeCountries: null,
      //   onlyForCountries: null,
      // },
      {
        rightSideImg: require('@/assets/images/banner/person_6.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'We make trading easy for you',
        subTitle:
          'With our award-winning customer service and powerful platforms, you have all the support you need to start trading.',
        buttonLink: `/depositFunds`,
        buttonText: 'Deposit Now',
        extraClass: ['info_left', 'title_single_line'],
        bannerVersion: 'v3',
        iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        excludeCountries: {
          [countryCodeEnum.PAKISTAN]: true,
          [countryCodeEnum.INDONESIA]: true,
          [countryCodeEnum.BANGLADESH]: true,
          [countryCodeEnum.SOUTH_AFRICA]: true,
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.MACAO]: true,
          [countryCodeEnum.TAIWAN]: true,
        },
        onlyForCountries: null,
      },
      {
        img: require('@/assets/images/banner/banner_new.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'Enjoy Your Trading Experience Anytime, Anywhere',
        bannerVersion: 'v1',
        excludeCountries: null,
        onlyForCountries: {
          [countryCodeEnum.TAIWAN]: true,
          [countryCodeEnum.HONG_KONG]: true,
        },
      },
      {
        rightSideImg: require('@/assets/images/banner/person_1.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'Gain advantage with extra trading power',
        subTitle: 'Get credit bonus for every deposit made to your live account up to $10,000!',
        // buttonLink: `/depositBonus`,
        buttonLink: `/depositFunds`,
        buttonText: 'Deposit Now',
        extraClass: 'info_left',
        bannerVersion: 'v3',
        iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        tncLink: 'https://go.vtmarkets.com/visit/?bta=35164&nci=5495&utm_campaign=clientportal',
        excludeCountries: {
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.MACAO]: true,
          [countryCodeEnum.TAIWAN]: true,
          [countryCodeEnum.VIETNAM]: true,
          [countryCodeEnum.THAILAND]: true,
          [countryCodeEnum.LAOS]: true,
          [countryCodeEnum.INDONESIA]: true,
          [countryCodeEnum.PAKISTAN]: true,
          [countryCodeEnum.MALAYSIA]: true,
          [countryCodeEnum.TURKEY]: true,
        },
        onlyForCountries: null,
      },
      {
        rightSideImg: require('@/assets/images/banner/person_2.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'Empowering your investment with everyday market insights',
        subTitle:
          'VT Market’s Daily Newsletter provides you with deep & reliable multi-dimensional market insights to boost your trading.',
        buttonLink: `https://www.vtmarkets.net/daily-market-analysis/`,
        // buttonLink: `/dailyNewsletter`,
        buttonText: 'Sign up',
        extraClass: 'info_left',
        bannerVersion: 'v3',
        iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        // tncLink: 'https://go.vtmarkets.com/visit/?bta=35164&nci=5490&utm_campaign=clientportal',
        excludeCountries: {
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.MACAO]: true,
        },
        onlyForCountries: null,
      },
      // {
      //   rightSideImg: require('@/assets/images/banner/person_3.png'),
      //   smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
      //   title: 'Start your trading & earn cash bonus',
      //   subTitle: 'Get your trading credit converted into cash for every trade you placed!',
      //   buttonLink: `https://go.vtmarkets.com/visit/?bta=35164&nci=5491&utm_campaign=CP`,
      //   buttonText: 'Sign up',
      //   extraClass: 'info_left',
      //   bannerVersion: 'v3',
      //   iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
      //   andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
      //   tncLink: 'https://go.vtmarkets.com/visit/?bta=35164&nci=5491&utm_campaign=clientportal ',
      //   excludeCountries: {
      //     [countryCodeEnum.CHINA]: true,
      //     [countryCodeEnum.HONG_KONG]: true,
      //     [countryCodeEnum.MACAO]: true,
      //     [countryCodeEnum.TAIWAN]: true,
      //     [countryCodeEnum.VIETNAM]: true,
      //     [countryCodeEnum.THAILAND]: true,
      //     [countryCodeEnum.LAOS]: true,
      //     [countryCodeEnum.INDONESIA]: true,
      //     [countryCodeEnum.PAKISTAN]: true,
      //     [countryCodeEnum.TURKEY]: true,
      //     [countryCodeEnum.MALAYSIA]: true,
      //   },
      //   onlyForCountries: null,
      // },
      {
        rightSideImg: require('@/assets/images/banner/person_4.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'banner.exploreEndlessOpportunity',
        subTitle: 'banner.exploreEndlessOpportunityDesc',
        // title: 'Trade on the go',
        // subTitle: 'Download VT Markets App and enjoy the all-in-one trading experience.',
        extraClass: 'info_left',
        downloadPic: true,
        bannerVersion: 'v5',
        // iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/CPDL',
        andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/CPDL',
        // andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        excludeCountries: {
          [countryCodeEnum.UNITED_KINGDOM]: true,
          [countryCodeEnum.FRANCE]: true,
          [countryCodeEnum.SPAIN]: true,
          [countryCodeEnum.PORTUGAL]: true,
          [countryCodeEnum.ITALY]: true,
          [countryCodeEnum.GERMANY]: true,
          [countryCodeEnum.TURKEY]: true,
        },
        onlyForCountries: null,
      },
      // {
      //   rightSideImg: require('@/assets/images/banner/person_5.png'),
      //   smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
      //   title: 'Good experiences are <br> worth sharing',
      //   subTitle:
      //     'Refer a friend and receive a consecutive cash bonus as they register, fund and trade with a live account.',
      //   buttonLink: `/referFriends`,
      //   buttonText: 'Start referring',
      //   extraClass: 'info_left',
      //   bannerVersion: 'v3',
      //   iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
      //   andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
      //   tncLink:
      //     'https://www.vtmarkets.com/my/promotions/friend-referral/refer-a-friend/#:~:text=View%20terms%20and%20conditions',
      //   excludeCountries: {
      //     [countryCodeEnum.CHINA]: true,
      //     [countryCodeEnum.HONG_KONG]: true,
      //     [countryCodeEnum.MACAO]: true,
      //     [countryCodeEnum.TAIWAN]: true,
      //     [countryCodeEnum.VIETNAM]: true,
      //     [countryCodeEnum.THAILAND]: true,
      //     [countryCodeEnum.INDONESIA]: true,
      //     [countryCodeEnum.PAKISTAN]: true,
      //     [countryCodeEnum.BANGLADESH]: true,
      //     [countryCodeEnum.SOUTH_AFRICA]: true,
      //     [countryCodeEnum.TURKEY]: true,
      //     [countryCodeEnum.MALAYSIA]: true,
      //   },
      //   onlyForCountries: null,
      // },
      {
        img: require('@/assets/images/banner/spinTheWheelBanner.png'),
        icon: require('@/assets/images/banner/spinTheWheelIcon.png'),
        title: 'Your Spark of Luck Awaits',
        subTitle: 'Light up 2025 with rewards up to $500!',
        bannerVersion: 'v8',
        excludeCountries: null,
        onlyForCountries: null,
      },
      {
        img: require('@/assets/images/banner/bannerTradeAndWin.png'),
        headingTitle: 'Trade & win 2.0',
        title: `Turn Every Trade into <span style='color: #00F0FF;'>Epic Rewards.</span>`,
        subTitle: `This is your opportunity to earn exciting rewards simply by trading  with us! Join our exclusive <span style='color: #00F0FF;'>Trade & Win 2.0</span>`,
        date: 'From 21 April 2025 - 20 June 2025',
        extraClass: 'info_left',
        bannerVersion: 'tradeAndWin',
        excludeCountries: null,
        onlyForCountries: { [countryCodeEnum.INDIA]: true },
      },
      {
        img: require('@/assets/images/banner/bannerIBArtboard.png'),
        headingTitle: 'IB Elite Explorer 2.0',
        title: '',
        subTitle: `Join India's largest IB partnership program & grow your network to earn cash bonuses, luxury getaways, and other exclusive perks.`,
        date: 'From 1 May 2025 - 31 Oct 2025',
        extraClass: 'info_left',
        bannerVersion: 'ibEliteExplorer',
        excludeCountries: null,
        onlyForCountries: { [countryCodeEnum.INDIA]: true },
      },
    ]
  },
  getWithdrawMethods: {
    1: 'Credit/Debit Card',
    2: {
      1: 'Bank Transfer (Australia)',
      2: 'Bank Transfer (International)',
      3: 'Bank Transfer (China)',
    },
    3: 'Skrill / Neteller',
    4: 'Union Pay',
    5: 'Internet Banking (Thailand)',
    6: 'Internet Banking (Malaysia)',
    7: 'FasaPay',
    8: 'Internet Banking (Vietnam)',
    9: 'Internet Banking (Nigeria)',
    24: 'Internet Banking (India)',
    31: 'Skrill',
    32: 'Neteller',
    33: 'Paypal',
    34: 'Cryptocurrency-Bitcoin',
    35: 'South Korea Instant Bank Wire Transfer',
    36: 'Cryptocurrency-USDT',
    37: 'Bitwallet',
    39: 'Internet Banking (Indonesia)',
    40: 'Internet Banking (Philippine)',
    42: 'Internet Banking (South Africa)',
    47: 'Internet Banking (Laos)',
    48: 'DasshpeUPI',
    49: 'Internet Banking (Hong Kong)',
    61: 'Perfect Money',
    62: 'Internet Banking (Japan)',
    63: 'Internet Banking (Mexico)',
    64: 'Pagsmile',
    65: 'Local Depositor',
    66: 'FPX2C2P',
    67: 'Internet banking (Nigeria)',
    75: 'Ebuy',
    80: 'Cryptocurrency-ETH',
    81: 'Cryptocurrency-USDC',
    86: 'USDT-TRC20',
    87: 'USDT-ERC20',
    88: 'Internet Banking (Chile)',
    89: 'Internet Banking (Colombia)',
    97: 'FX-IR',
    99: 'Interac',
    100: 'PIX',
    106: 'Cryptocurrency-USDT(BEP20)',
    108: 'Internet Banking (UAE)',
    109: 'ewalletuppercase', // AirTM-CPS(E-Wallet)
    110: 'Internet Banking (EU)',
    115: 'E-Wallet (Bangladesh)',
    117: 'Nagad',
    118: 'Rocket',
    122: 'TCPay',
    129: 'International Bank Transfer-International',
  },
  restrictDepositFundsByCountries: [
    // 4575, //Canada
  ],
  restrictOpenAdditionAccountCountries: [
    // 4575, //Canada
  ],
}
